<p-dialog [(visible)]="displayModal" [modal]="true" [autoZIndex]="true" [draggable]="false" [resizable]="true"
	[maximizable]="true" [breakpoints]="{'960px': '100vw'}" [style]="{width: '85vw'}">
	<p-toast></p-toast>
	<ng-template pTemplate="header">
		<CustomTitle [title]="header + ('components.app-options-builder.options' | translate)" />
	</ng-template>

	<ng-template pTemplate="content">

		<div class="pb-1">
			<p-toolbar>
				<div class="p-toolbar-group-left flex flex-wrap gap-2">
					<div class="flex flex-wrap gap-1">
						<div class="flex align-items-center gap-1">
							<input pInputText id="addInput" type="text" [placeholder]="'components.app-options-builder.addInput' | translate" [formControl]="addInput"
								aria-describedby="addInput-help" maxlength="100">
							<ng-container *ngIf="addInput.invalid && addInput.touched && addInput.dirty">
								<i id="addInput-help" class="p-error pi pi-info-circle"
									pTooltip="Must not be empty. <br/>Must not have whitespaces. <br/>Must be unique." [escape]="false"
									tooltipPosition="top"></i>
							</ng-container>
						</div>
						<button pButton type="button" icon="pi pi-plus" class="p-button-outlined" (click)="addColumn()"></button>
					</div>
					<div class="flex flex-wrap gap-2">
						<p-dropdown id="deleteDropdown" [options]="deletableCols" [placeholder]="'components.app-options-builder.deleteDropdown' | translate"
							[formControl]="deleteDropdown" [showClear]="true"></p-dropdown>
						<button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-outlined"
							(click)="deleteColumn()"></button>
					</div>
				</div>
				<div class="p-toolbar-group-right">
					<p-fileUpload #fileUpload mode="basic" accept=".xls,.xlsx" chooseStyleClass="p-button-sm"
						chooseIcon="pi pi-upload" [chooseLabel]="'form.button.fileUpload-choose' | translate" [customUpload]="true" [auto]="true"
						(uploadHandler)="uploadHandler($event, fileUpload)"></p-fileUpload>
				</div>
			</p-toolbar>
		</div>
		<div>
			<p-table [columns]="cols" [value]="editableOptions" styleClass="p-datatable-sm p-datatable-gridlines" dataKey="id"
				editMode="row" [tableStyle]="{'min-width': '50rem'}" [rows]="10" [paginator]="true"
				[scrollable]="true" scrollHeight="400px">
				<ng-template pTemplate="caption">
					<div class="flex justify-content-end">
						<div CustomCreateButton (onClick)="addRow()">
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th *ngFor="let col of cols" scope="col">
							{{col}}
						</th>
						<th style="width:75px" scope="col"></th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-option let-columns="columns" let-editing="editing" let-ri="rowIndex">
					<tr [pEditableRow]="option">
						<td *ngFor="let col of cols">
							<p-cellEditor>
								<ng-template pTemplate="input">
									<input pInputText type="text" [(ngModel)]="option[col]" required>
								</ng-template>
								<ng-template pTemplate="output">
									{{option[col]}}
								</ng-template>
							</p-cellEditor>
						</td>
						<td>
							<div class="flex align-items-center justify-content-center gap-2">
								<button *ngIf="!editing" pButton type="button" pInitEditableRow icon="pi pi-pencil"
									(click)="onRowEditInit(option)" class="p-button-rounded p-button-text"></button>
								<button *ngIf="!editing" pButton type="button" icon="pi pi-times" (click)="onDeleteRow(ri)"
									class="p-button-rounded p-button-text p-button-danger"></button>
								<button *ngIf="editing" pButton type="button" pSaveEditableRow icon="pi pi-check"
									(click)="onRowEditSave(option)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
								<button *ngIf="editing" pButton type="button" pCancelEditableRow icon="pi pi-times"
									(click)="onRowEditCancel(option, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</ng-template>

	<ng-template pTemplate="footer">
		<button pButton type="button" [label]="'form.button.aplicar' | translate" icon="pi pi-save" (click)="applyOptions()" class="tax-app-button"></button>
	</ng-template>
</p-dialog>